export const sidebarTranslations = {
  fr: {
    dashboard: {
      name: "Accueil",
      description: "Tableau de bord"
    },
    forum: {
      name: "Forum",
      description: "Discussions"
    },
    messages: {
      name: "Messages",
      description: "Messagerie privée"
    },
    documents: {
      name: "Documents",
      description: "Documents partagés"
    },
    council: {
      name: "Conseil",
      description: "Membres du conseil"
    },
    assistance: {
      name: "Assistance",
      description: "Support"
    },
    myPosts: {
      name: "Mes publications",
      description: "Gérer mes publications"
    },
    admin: {
      name: "Administration",
      description: "Gérer la plateforme"
    },
    legal: {
      title: "Informations légales",
      mentions: "Mentions légales",
      terms: "Conditions générales",
      privacy: "Politique de confidentialité",
      cookies: "Politique des cookies",
      rules: "Règlement du forum"
    },
    logout: "Déconnexion"
  },
  en: {
    dashboard: {
      name: "Home",
      description: "Dashboard"
    },
    forum: {
      name: "Forum",
      description: "Discussions"
    },
    messages: {
      name: "Messages",
      description: "Private messaging"
    },
    documents: {
      name: "Documents",
      description: "Shared documents"
    },
    council: {
      name: "Council",
      description: "Council members"
    },
    assistance: {
      name: "Support",
      description: "Help desk"
    },
    myPosts: {
      name: "My posts",
      description: "Manage my posts"
    },
    admin: {
      name: "Administration",
      description: "Manage platform"
    },
    legal: {
      title: "Legal Information",
      mentions: "Legal Notice",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      rules: "Forum Rules"
    },
    logout: "Logout"
  },
  it: {
    dashboard: {
      name: "Home",
      description: "Dashboard"
    },
    forum: {
      name: "Forum",
      description: "Discussioni"
    },
    messages: {
      name: "Messaggi",
      description: "Messaggistica privata"
    },
    documents: {
      name: "Documenti",
      description: "Documenti condivisi"
    },
    council: {
      name: "Consiglio",
      description: "Membri del consiglio"
    },
    assistance: {
      name: "Assistenza",
      description: "Supporto"
    },
    myPosts: {
      name: "I miei post",
      description: "Gestisci i miei post"
    },
    admin: {
      name: "Amministrazione",
      description: "Gestisci piattaforma"
    },
    legal: {
      title: "Informazioni legali",
      mentions: "Note legali",
      terms: "Termini di servizio",
      privacy: "Privacy",
      cookies: "Cookie",
      rules: "Regole del forum"
    },
    logout: "Esci"
  }
};